export const CANCEL_PAUSE_REQUEST_MODAL_STAGES = {
  notOpen: 'notOpen',
  confirm: 'confirm',
  success: 'success',
};
